module.exports = __webpack_public_path__ + "fonts/NotoSansGeorgian-Regular.e55178c8.woff";